import * as S from './modal-default-desktop.styled'
import Cross from '@components/Icons/Cross'
import React from 'react'

interface ModalDefaultDesktopProps {
    isOpened: boolean
    title?: string
    closeHandler: () => void
    children: any
    modalName: string
}

export const ModalDefaultDesktop = ({
    isOpened,
    title,
    closeHandler,
    children,
    modalName
}: ModalDefaultDesktopProps) => {
    return (
        <S.Container ZIndex={60} data-modal-name={modalName} isOpened={isOpened}>
            <S.Background isOpened={isOpened}>
                <S.Modal>
                    <S.Header>
                        <S.HeaderTitle>{title}</S.HeaderTitle>
                        <S.ButtonClose onClick={closeHandler}>
                            <Cross />
                        </S.ButtonClose>
                    </S.Header>
                    <S.Body>{children}</S.Body>
                </S.Modal>
            </S.Background>
        </S.Container>
    )
}
